import { observer } from "mobx-react-lite";
import React from "react";

interface IProps {
	iframeSourceUrl: string;
}

export const IFrame: React.FC<IProps> = observer((props) => {
	const { iframeSourceUrl } = props;

	return (
		<div style={{ overflow: "hidden" }}>
			<iframe
				style={{ position: "absolute", width: "100vw", minHeight: "100vh" }}
				allowFullScreen
				src={iframeSourceUrl}
				allow="camera;fullscreen;accelerometer;gyroscope;magnetometer;"
			/>
		</div>
	);
});

export default IFrame;
